import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
// Meta Pixel global declaration
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  href,
  children,
  className = '',
  fullWidth = false
}) => {
  const handleClick = () => {
    // Fire Meta Pixel AddToCart event when CTA is clicked
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'Libera a tu Mujer Interior',
        content_category: 'Guía Digital',
        currency: 'ARS',
        value: 25990
      });
    }
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center gap-2 
        bg-brand-burgundy hover:bg-brand-wine text-white 
        font-semibold py-4 px-8 rounded-full shadow-lg 
        hover:shadow-xl transition-all duration-300
        ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
        ${className}
      `} data-id="element-46">
      <span className="text-lg md:text-xl" data-id="element-47">{children}</span>
      <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-48" />
    </motion.a>;
};